module.exports = __webpack_public_path__ + "img/pdf-icon-hover.28a51133.svg";